import { get } from 'lodash'
import styled from 'styled-components'

import Loader from '@/utilities/client-components/components/Loader/Loader'
import NotificationErrorBoundary from '@/utilities/client-components/components/NotificationErrorBoundary'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

import ActionSet from './ActionSet'
import AdaptiveCardBody from './AdaptiveCardBody'
import BaseAdaptiveCard from './BaseAdaptiveCard'

const StyledDetailAdaptiveCard = styled.div`
  position: relative;
  padding-right: ${(props: any) => get(props.theme, 'spacing.padding', 0)}px;
  padding-bottom: ${(props: any) => (props.hasActions ? 0 : get(props.theme, 'spacing.padding', 0))}px;
  padding-left: ${(props: any) => get(props.theme, 'spacing.padding', 0)}px;
  background-color: ${({ theme }: any) => themeUtilities.getColor(theme, 'default', 'background')};
  margin-top: 10px;
  margin-bottom: ${(props: any) => get(props.theme, 'summaryCardMargin')}px;
`
const StyledDetailAdaptiveCardContent = styled.div`
  position: relative;
`
const StyledLoadingWrapper = styled.div`
  position: absolute;
  inset: 0;
  height: 5rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: ${(props: any) => props.theme.baseZ};
`

interface DetailAdaptiveCardProps {
  actionHandler(...args: unknown[]): unknown
  card: object
  disableActions?: boolean
  document?: object
  loading?: boolean
  notification: object
}

// @ts-expect-error
class DetailAdaptiveCard extends BaseAdaptiveCard<DetailAdaptiveCardProps> {
  static displayName = 'DetailAdaptiveCard'
  static defaultProps = {
    styleOverrides: {}
  }

  constructor(props: any) {
    super(props)

    this.shouldDisplayActions = this.shouldDisplayActions.bind(this)

    // @ts-expect-error
    this.state = {
      showConfirmation: false
    }
  }

  renderLoading() {
    return (
      <StyledLoadingWrapper>
        <Loader />
      </StyledLoadingWrapper>
    )
  }

  async actionHandler(actionType: any, actionTitle: any, options: any) {
    await super.actionHandler(actionType, actionTitle, {
      ...options,
      analytics: { ...options.analytics, 'workgrid-panel': 'detail' }
    })

    if (options.confirmation) {
      // @ts-expect-error
      this.setState({
        showConfirmation: true,
        confirmation: options.confirmation
      })
    }
  }

  shouldDisplayActions(card: any) {
    // @ts-expect-error
    return get(card, 'actions', []).length > 0 && !this.state.showConfirmation
  }

  render() {
    // @ts-expect-error
    const { card, notification, loading, document, disableActions } = this.props

    if (!notification) return null

    return (
      <NotificationErrorBoundary notificationId={notification.id} fullscreen={true}>
        {/* @ts-expect-error */}
        <StyledDetailAdaptiveCard hasActions={card.actions && card.actions.length > 0} data-id={'wg-ac-detail-card'}>
          {loading ? (
            this.renderLoading()
          ) : (
            <StyledDetailAdaptiveCardContent>
              <AdaptiveCardBody
                notificationId={notification.id}
                // @ts-expect-error
                body={this.state.showConfirmation ? this.state.confirmation.body : card.body}
                actionHandler={this.actionHandler}
                // @ts-expect-error
                registerInputCallback={this.registerInputCallback}
                document={document}
              />
              {this.shouldDisplayActions(card) && (
                <ActionSet disabled={disableActions} actions={card.actions} actionHandler={this.actionHandler} />
              )}
            </StyledDetailAdaptiveCardContent>
          )}
        </StyledDetailAdaptiveCard>
      </NotificationErrorBoundary>
    )
  }
}

export default DetailAdaptiveCard
